import { Avatar } from "@ameelio/ui";
import {
  Stack,
  Typography,
  useMediaQuery as measureScreenWidth,
} from "@mui/material";
import { belowLargeTablet } from "../../lib/responsiveHelpers";

type CaptionsBoxProps = {
  user: { fullName: string };
  message: string;
};

export default function CaptionBox({ user, message }: CaptionsBoxProps) {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        mb: 1,
        alignItems: "center",
        borderRadius: 2,
      }}
    >
      <Avatar contact={user} />
      <Typography
        variant={belowLargeTablet(measureScreenWidth) ? "body2" : "h3"}
        component="span"
        sx={{
          color: "common.white",
        }}
      >
        {message}
      </Typography>
    </Stack>
  );
}
